module.exports = __webpack_public_path__ + "static/media/FEDE2.ac47fb93.png";